import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import exportValue from "../../apiconfig";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import "../../components/loader.css";

const Vas_prices = () => {

    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);

        const homeSection = document.querySelector(".home-section");

        if (homeSection) {
            homeSection.classList.toggle("sidebar-closed");
        }
    };



    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        timer: 3000,
        showConfirmButton: false
    });


    useEffect(() => {
        getPlans();
    }, []);



    const getPlans = () => {

        setLoading(true);


        let api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/get_subscription_plans";


        axios.post(api, {}, {
            headers: exportValue.headers
        })
            .then((res) => {

                setPlans(res.data.output || []);

                setLoading(false);

            })
            .catch(() => {

                setLoading(false);

            });

    };



    const handleChange = (index, e) => {

        const temp = [...plans];

        temp[index][e.target.name] = e.target.value;

        setPlans(temp);

    };




    const updatePlan = (plan) => {

        let api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/update_subscription_plan";



        axios.post(
            api,
            plan,
            {
                headers: exportValue.headers
            }
        )

            .then((res) => {


                if (res.data.status === 200) {


                    Toast.fire({

                        icon: "success",
                        title: "Updated Successfully",
                        background: "#10b93b",
                        color: "#fff"

                    });

                }


            })

            .catch(() => {



                Toast.fire({

                    icon: "error",
                    title: "Something went wrong"

                });

            });

    };






    return (

        <>


            <Left_panel
                isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
            />



            <section className="home-section">

                <Sub_header />




                <div className="py-4">

                    <h2 className="h4">

                        Subscription Plans


                    </h2>

                </div>




                {
                    loading ?

                        <div className="text-center">

                            <div className="spinner-border text-primary" />

                        </div>


                        :

                        plans.map((plan, index) => (



                            <div
                                className="card shadow border-0 mb-4"
                                key={index}
                            >




                                <div className="card-header bg-light">


                                    <h5 className="mb-0">


                                        {plan.plan_name}



                                    </h5>


                                </div>





                                <div className="card-body">



                                    <div className="row g-3">





                                        <div className="col-md-3">

                                            <label className="form-label">

                                                Plan Price

                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="monthly_price"

                                                    value={plan.monthly_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />


                                            </div>

                                        </div>





                                        <div className="col-md-3">

                                            <label className="form-label">

                                                Free Orders

                                            </label>

                                            <input

                                                type="number"

                                                className="form-control"

                                                name="free_orders"

                                                value={plan.free_orders || ""}

                                                onChange={(e) => handleChange(index, e)}

                                            />

                                        </div>






                                        <div className="col-md-3">

                                            <label className="form-label">

                                            AfterShip Premium

                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="delivery_update_price"

                                                    value={plan.delivery_update_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />

                                            </div>

                                        </div>





                                        <div className="col-md-3">

                                            <label className="form-label">

                                            Product Image based COD Verification

                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="cod_verification_price"

                                                    value={plan.cod_verification_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />

                                            </div>

                                        </div>






                                        <div className="col-md-3">

                                            <label className="form-label">

                                            TrueReach™ COD Shield
                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="cod_shield_price"

                                                    value={plan.cod_shield_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />

                                            </div>

                                        </div>






                                        <div className="col-md-3">

                                            <label className="form-label">

                                            TrueReach™ RTO Shield

                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>



                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="rto_shield_price"

                                                    value={plan.rto_shield_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />

                                            </div>

                                        </div>






                                        <div className="col-md-3">

                                            <label className="form-label">

                                            TrueWeight™ Shield

                                            </label>

                                            <div className="input-group">

                                                <span className="input-group-text">

                                                    INR

                                                </span>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    name="trueweight_price"

                                                    value={plan.trueweight_price || ""}

                                                    onChange={(e) => handleChange(index, e)}

                                                />

                                            </div>

                                        </div>





                                    </div>




                                    <div className="mt-4">


                                        <button

                                            className="btn btn-gray-800"

                                            onClick={() => updatePlan(plan)}
                                        >


                                            Save


                                        </button>



                                    </div>




                                </div>

                            </div>




                        ))

                }

            </section>

        </>

    );
};

export default Vas_prices;